// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
	static values = { 
		env: String,
		email: String
	}
	newcard() {
		var handler = StripeCheckout.configure({
			key:
				this.envValue === 'production'
					? 'pk_live_UoNGQ4CzuJB0JIOLi99hjubL00OJ3QDw5d'
					: 'pk_test_51Gv8d5LwGPQV66wYUJ3a2a2tnEmtvYEF1AU2Pj8dtvmo8DzZVGbLSGwmwSUIkEboXF1sLEVk1zF6tL0GxrxfThKp00wfEd6S68',
			//get a publishable key that we put in editor depending on environment: production or development
			locale: 'auto',
			//handle translation
			name: 'Silhouette & Shadow',
			description: 'Add your credit card information',
			email: this.emailValue,
			panelLabel: 'Add payment method',
			allowRememberMe: false,
			token: function (token) {
				var form = document.getElementById('billing-create-payment-method');
				//we will create element with this id in the next step
				var hiddenInput = document.createElement('input');
				hiddenInput.setAttribute('type', 'hidden');
				hiddenInput.setAttribute('name', 'stripeToken');
				hiddenInput.setAttribute('value', token.id);
				//creating an <input type="hidden" name="stripeToken" value="<id>"/>. We will need this information in the next steps to link a user to his card
				form.appendChild(hiddenInput);
				//adding this input when we use a form.
				form.submit();
			},
		});

		handler.open();

		window.addEventListener('popstate', function () {
			handler.close();
		});
	}
}
